import styled, { css } from "styled-components";

export const SubCheckboxWrapper = styled.div`
  ${({ theme: { tokens } }) => css`
    margin-left: ${tokens.sizes.spacings.tera};
  `}
`;
